import { Report, Engineering, Grading, Home, Place, Analytics } from "@mui/icons-material"

const adminPembangunanRoutes = [
    {
        type: "route",
        name: "Dashboard",
        key: ['/a-pemb'],
        route: "/a-pemb",
        icon: <Home size="12px" color="warning" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "Perencanaan",
        key: ['/a-pemb/perencanaan', '/a-pemb/perencanaan/rincian-belanja'],
        route: "/a-pemb/perencanaan",
        icon: <Analytics size="12px" color="info" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "Laporan",
        key: ['/a-pemb/laporan', '/a-pemb/laporan/detail', '/a-pemb/laporan/rincian-belanja', '/a-pemb/laporan/komponen'],
        route: "/a-pemb/laporan",
        icon: <Report size="12px" color="secondary" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "Lokasi Pekerjaan",
        key: ['/a-pemb/lokasi-pekerjaan'],
        route: "/a-pemb/lokasi-pekerjaan",
        icon: <Place size="12px" color="success" />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Paket Pekerjaan",
        key: ['paket-pekerjaan', 'proyek-strategis', 'proyek-dak'],
        icon: <Engineering size="12px" color="error" />,
        collapse: [
            {
                name: "Komponen Belanja",
                key: ['/a-pemb/belanja'],
                route: "/a-pemb/belanja",
            },
            {
                name: "Belanja Modal",
                key: ['/a-pemb/belanja-modal'],
                route: "/a-pemb/belanja-modal",
            },
            {
                name: "Proyek Strategis",
                key: ['/a-pemb/proyek-strategis'],
                route: "/a-pemb/proyek-strategis",
            },
            {
                name: "Proyek DAK",
                key: ['/a-pemb/proyek-dak'],
                route: "/a-pemb/proyek-dak",
            },
        ],
    }
]

export default adminPembangunanRoutes